module.exports = __webpack_public_path__ + "img/pdf_document.339eb5f3.svg";